import PropTypes from 'prop-types';
import { IconButton, Stack, TextField } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

// Selector de cantidad (- / campo / +) reutilizado en la tarjeta de producto, la ficha de
// detalle, el carrito (pagina y panel) y la cotizacion. El campo oculta las flechitas nativas
// del input numerico y les da ancho fijo: sin esto, en tarjetas angostas el numero quedaba
// tapado por esas flechas al presionar + o -.
export default function QuantityStepper({ value, onChange, disabled = false, min = 1, size = 'small' }) {
  const clamp = (raw) => Math.max(min, Number(raw) || min);

  return (
    <Stack sx={{ alignItems: 'center' }} direction="row" spacing={0.5}>
      <IconButton size={size} onClick={() => onChange(clamp(value - 1))} disabled={disabled || value <= min}>
        <RemoveIcon fontSize="small" />
      </IconButton>
      <TextField
        type="number"
        size={size}
        value={value}
        onChange={(e) => onChange(clamp(e.target.value))}
        disabled={disabled}
        slotProps={{ htmlInput: { min, style: { textAlign: 'center' } } }}
        sx={{
          width: 60,
          '& input[type=number]': { MozAppearance: 'textfield' },
          '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        }}
      />
      <IconButton size={size} onClick={() => onChange(clamp(value + 1))} disabled={disabled}>
        <AddIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}

QuantityStepper.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  size: PropTypes.oneOf(['small', 'medium']),
};
